import React, { useState } from 'react';
import lodash from 'lodash';
import moment from 'moment'

import { detectIconById } from '../../../../common/enum';

export const renderTitleGame = (data) => {
    return (
        <p className='date-time'>{data.stadium_name} &emsp; {data.home.team.team_name_s} - {data.away.team.team_name_s} &ensp;{data.round}回戦&emsp; {data.game_started_time}開始</p>
    )
}

export const renderBadge = (data) => {
    return (
        <p className={data.game_status.game_end_sec === null ? '' : data.game_status.game_end_sec === 1 ? 'badge-green' : data.game_status.game_end_sec === 2 ? 'badge-yellow' : 'badge-gray'}>{data.display_status}</p>
    )
}

export const renderTeam = (team, data) => {
    const img = detectIconById(team.id)
    const cond = !data.current.batter ?
        {
            name: '',
            type: ''
        } :
        team.id === data.current.pitcher.team.id ?
            {
                name: '投手',
                type: data.current.pitcher.player_name_s
            } :
            {
                name: '打者',
                type: data.current.batter.player_name_s
            };
    return (
        <div className='team-badge'>
            <div className='team-brand'>
                <img src={img} alt="" />{team.team_name_s}
            </div>
            <div className='pick-type'>{cond.name}<span>{cond.type}</span></div>
        </div>
    )
}

export const renderScoreMatch = (data, history) => {
    return (
        <div className='score-match' onClick={() => history.push(`/live/${data.id}`)}>
            {renderTeam(data.home.team, data)}
            {renderScore(data)}
            {renderTeam(data.away.team, data)}
        </div>

    )
}

export const renderScore = (data) => {
    const scores = {
        top_bottom_id: data.current.top_bottom_id,
        out: data.current.out,
        runners: data.current.runners,
    }
    return (
        <div className='score-wrap'>
            <div className='score'>
                <span style={scores.top_bottom_id === 2 ? { borderBottom: "4px solid #FA3E3E" } : {}}>{data.result.bottom.total}</span>
                <span>-</span>
                <span style={scores.top_bottom_id === 1 ? { borderBottom: "4px solid #FA3E3E" } : {}}>{data.result.top.total}</span>
            </div>
            <div className='d-flex-center'>
                <div className='out-circle'>
                    OUT
                    <div className='circle' style={scores.out >= 1 ? { backgroundColor: "#FA3E3E" } : {}}></div>
                    <div className='circle' style={scores.out >= 2 ? { backgroundColor: "#FA3E3E" } : {}}></div>
                    <div className='circle' style={scores.out >= 3 ? { backgroundColor: "#FA3E3E" } : {}}></div>
                </div>
                <div className='runners'>
                    <div className='rectangle-rotate padding-full' style={scores.runners[0] === '1' ? { backgroundColor: "#3D3DF2", border: 'unset' } : {}}></div>
                    <div className='rectangle-rotate rectangle-div' style={scores.runners[2] === '1' ? { backgroundColor: "#3D3DF2", border: 'unset' } : {}}></div>
                    <div className='rectangle-rotate rectangle-div-second' style={scores.runners[1] === '1' ? { backgroundColor: "#3D3DF2", border: 'unset' } : {}}></div>
                </div>
            </div>
        </div>
    )
}

export const renderTableScoreRound = (data, history) => {
    const inningRow = data.innings.map(item => item.inning).concat(['', '', '']).slice(0, 12)
    const header = lodash.concat(['チーム'], inningRow);
    const topResult = lodash.map(data.result.top, item => item || 0);
    const bottomResult = lodash.map(data.result.bottom, item => item || 0);
    const chunichi = data.innings.map(item => item.top.is_x ? item.top.r + "x" : item.top.r);
    const giant = data.innings.map(item => {
        if (item.bottom && item.bottom.is_x) {
            return item.bottom.r + "x";
        } else if (item.bottom) {
            return item.bottom.r;
        } else {
            return null;
        }
    });

    const topRow = lodash.concat(data.away.team.team_name_s, chunichi, topResult);
    const botRow = lodash.concat(data.home.team.team_name_s, giant, bottomResult);

    if (chunichi.length === 9) {
        topRow.splice(10, 0, '', '', '')
    }
    if (giant.length === 9) {
        botRow.splice(10, 0, '', '', '')
    }
    if (chunichi.length === 10) {
        topRow.splice(11, 0, '', '')
    }
    if (giant.length === 10) {
        botRow.splice(11, 0, '', '')
    }

    return (
        <table className='table-score-round' onClick={() => history.push(`/live/${data.id}`)}>
            <thead>
                <tr>
                    {
                        header.map((item, index) => {
                            return (<td key={'header' + index + moment().unix()} className='cell-header'>{item}</td>)
                        })
                    }
                    <td style={{ backgroundColor: '#E8ECEF' }} className='cell-header'>計</td>
                    <td style={{ backgroundColor: '#E8ECEF' }} className='cell-header'>安</td>
                    <td style={{ backgroundColor: '#E8ECEF' }} className='cell-header'>失</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    {
                        topRow.map((item, index) => {
                            return (<td key={'cell' + index + moment().unix()} style={
                                item && String(item) !== '0' && index === data.current.inning && data.current.top_bottom_id === 1 ? { fontWeight: 'bold', border: '2px solid #FF0000' } :
                                    item && String(item) !== '0' ? { fontWeight: 'bold' } :
                                        index === data.current.inning && data.current.top_bottom_id === 1 ? { border: '2px solid #FF0000' } : {}}>{item}</td>)

                        })
                    }
                </tr>
                <tr>
                    {
                        botRow.map((item, index) => {
                            return (<td key={'cell' + index + moment().unix()} style={
                                item && String(item) !== '0' && index === data.current.inning && data.current.top_bottom_id === 2 ? { fontWeight: 'bold', border: '2px solid #FF0000' } :
                                    item && String(item) !== '0' ? { fontWeight: 'bold' } :
                                        index === data.current.inning && data.current.top_bottom_id === 2 ? { border: '2px solid #FF0000' } : {}}>{item}</td>)
                        })
                    }
                </tr>
            </tbody>
        </table>
    )
}


export const GameCard = (props) => {
    const { gameData, history } = props;
    const [isCollapseTable, setIsCollapseTable] = useState(gameData.game_status.is_game_completed !== 1);
    const renderBatteriesHomeRuns = (data) => {
        // console.log(data)
        return (
            <>
                <table className='table-batteries-homeruns'>
                    {
                        data.game_status.game_end_sec > 2 && data.responsible_pitchers && data.responsible_pitchers.length > 0 && (
                            <>
                                <tr>
                                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center' }}>投手勝敗</td>
                                    <td>{
                                        data.responsible_pitchers.map((item, idx) => <span key={idx}>{item.w_l_sv_type_name + ' : ' + item.player_name_s}{item.stats && <span>&nbsp;({item.stats.w}勝{item.stats.l}敗{item.stats.sv}S)</span>}&nbsp;&nbsp;</span>)}</td>
                                </tr>
                            </>
                        )
                    }

                    {
                        (!isCollapseTable || gameData.game_status.game_end_sec === 2) && (
                            <>
                                <tr>
                                    <td rowSpan={2} style={{ backgroundColor: '#F7FAFC', textAlign: 'center', width: 92 }}>継投</td>
                                    <td>[{data.away.team.team_name_s}] {
                                        data.away.batteries.pitchers.map((item, index) => (index === 0 ? '' : ', ') + item.player_name_s)
                                    }</td>
                                </tr>
                                <tr>
                                    <td>[{data.home.team.team_name_s}] {
                                        data.home.batteries.pitchers.map((item, index) => (index === 0 ? '' : ', ') + item.player_name_s)
                                    }</td>
                                </tr>
                                <tr>
                                    <td rowSpan={2} style={{ backgroundColor: '#F7FAFC', textAlign: 'center' }}>本塁打</td>
                                    <td>[{data.away.team.team_name_s}] {
                                        data.away.homeruns.length > 0 && data.away.homeruns.map((item, index) => (index === 0 ? '' : ', ') + item.player.player_name_s + item.number + '号' + item.type_name + '(' + item.inning + '回表)')
                                    }</td>
                                </tr>
                                <tr>
                                    <td>[{data.home.team.team_name_s}] {
                                        data.home.homeruns.length > 0 && data.home.homeruns.map((item, index) => (index === 0 ? '' : ', ') + item.player.player_name_s + item.number + '号' + item.type_name + '(' + item.inning + '回裏)')
                                    }</td>
                                </tr>
                            </>
                        )
                    }
                </table>
                {
                    data.game_status.game_end_sec > 2 && (<button onClick={() => setIsCollapseTable(!isCollapseTable)} className='btn-collapse-table-row'>
                        {isCollapseTable ? <img src="/img/add_24px.svg" alt="" /> : <img src="/img/minus_icon.png" width={24} height={24} alt="" />}<span>継投・本塁打</span></button>)
                }
            </>
        )
    }
    return (
        <div className='game_card_content'>
            <div className='d-flex'>
                {renderTitleGame(gameData)}
                {renderBadge(gameData)}
            </div>
            {renderScoreMatch(gameData, history)}
            {renderTableScoreRound(gameData, history)}
            {renderBatteriesHomeRuns(gameData)}
        </div>
    );
}
